import { render } from "./Statistic.vue?vue&type=template&id=4ba1d70a"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__